import React from "react";

function Katour() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Katour</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Katour</strong> is a trusted name in the bicycle industry,
          operating from the vibrant manufacturing hub of Ludhiana. Renowned as
          both a manufacturer and importer of premium bicycle parts, Katour has
          established itself as the Original Equipment Manufacturer (OEM) for
          several leading bicycle brands in India.
        </p>
      </div>

      {/* About the Brand */}
      <div className="max-sm:px-4 space-y-4">
        <p className="text-gray-700 text-sm leading-relaxed">
          With a focus on quality and reliability, Katour specializes in bicycle
          spare parts, accessories, and complete bicycles, catering to a wide
          spectrum of consumer and business needs. Their extensive experience,
          spanning decades, underscores their commitment to excellence and
          innovation in the industry.
        </p>
        <p className="text-gray-700 text-sm leading-relaxed">
          Katour has forged strategic partnerships with globally recognized
          component manufacturers to bring high-quality and cost-effective
          generic bicycle parts to the Indian market. This collaboration ensures
          a seamless supply chain and access to cutting-edge technology, further
          reinforcing their position as a leader in the bicycle ecosystem.
        </p>
        <p className="text-gray-700 text-sm leading-relaxed">
          Driven by a passion for delivering exceptional service and dependable
          products, Katour continues to set benchmarks for quality and
          performance in the cycling industry. Whether it’s components or
          complete bicycles, Katour remains a trusted partner for businesses and
          cycling enthusiasts alike.
        </p>
      </div>
    </div>
  );
}

export default Katour;
